export default __webpack_public_path__ + "static/media/slider1.89946114.jpg";